<template>
    <div class="drop-zone">
        <div class="gallery">
            <div
                class="gallery-item"
                v-for="(file, fileIndex) in value.filter((x) => !x.removed)"
                :key="'file.' + fileIndex">
                <div class="inner">
                    <i
                        class="fa fa-remove"
                        @click="
                            file.removed = true;
                            fileRemoved(file);
                        " />
                    <img :src="file.previewSrc" />
                    <i
                        class="fa fa-check"
                        :class="{ 'is-main': file.isMain }"
                        @click="setMain(file, !file.isMain)" />
                </div>
                <ui5-progress-indicator
                    v-if="file.newFile"
                    max="100"
                    :value="file.progress"></ui5-progress-indicator>
            </div>
        </div>

        <div class="drop-area" ref="dropArea">
            <ui5-file-uploader
                hide-input
                multiple="true"
                @change="handleFiles"
                :accept="mimes.join(',')">
                <div class="uploader-content">
                    <span>Afbeeldingen toevoegen</span>
                    <br />
                    <i class="fa fa-upload" />
                    <i class="fa fa-camera" />
                </div>
            </ui5-file-uploader>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Array,
            required: true,
        },
        uploadFiles: {
            type: Function,
            required: false,
        },
        fileRemoved: {
            type: Function,
            required: false,
            default: () => {},
        },
        mainImageSet: {
            type: Function,
            required: false,
            default: () => {},
        },
        mimes: {
            type: Array,
            required: true,
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.$emit('input', this.value);
            },
        },
    },
    data() {
        return {
            uploadProgress: null,
            dropArea: null,
        };
    },
    methods: {
        setMain(file, isMain) {
            this.value.forEach((x) => {
                x.isMain = false;
            });
            if (isMain) {
                file.isMain = true;
                this.mainImageSet(file);
            } else {
                this.value[0].isMain = true;
                this.mainImageSet(this.value[0]);
            }
        },
        preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        handleFilesInner(files) {
            const newFiles = [];
            const previewPromises = files
                .filter((file) => this.mimes.includes(file.type))
                .map((file) => {
                    return this.createFileWithPreview(file).then((fileItem) => {
                        newFiles.push(fileItem);
                        this.value.push(fileItem);
                    });
                });

            Promise.all(previewPromises).then(() => {
                if (this.uploadFiles && newFiles.length) {
                    this.uploadFiles(newFiles);
                }
            });
        },
        handleFiles($event) {
            const files = [...$event.target.files];
            this.handleFilesInner(files);
        },
        handleDrop(e) {
            this.handleFilesInner([...e.dataTransfer.files]);
        },
        createFileWithPreview(file) {
            return new Promise((resolve, reject) => {
                const result = {
                    ID: null,
                    fileObject: file,
                    newFile: true,
                    removed: false,
                    progress: 0,
                    isMain: this.value.length == 0,
                };
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    result.previewSrc = reader.result;
                    resolve(result);
                };
            });
        },
        highlight() {
            this.$refs.dropArea.classList.add('drop-area-highlight');
        },
        unhighlight() {
            this.$refs.dropArea.classList.remove('drop-area-highlight');
        },
    },
    computed: {},
    mounted() {
        this.$refs.dropArea = document.querySelector('.drop-area');

        // Prevent default drag behaviors
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
            this.$refs.dropArea.addEventListener(
                eventName,
                this.preventDefaults,
                false
            );
        });

        ['dragenter', 'dragover'].forEach((eventName) => {
            this.$refs.dropArea.addEventListener(
                eventName,
                this.highlight,
                false
            );
        });

        ['dragleave', 'drop'].forEach((eventName) => {
            this.$refs.dropArea.addEventListener(
                eventName,
                this.unhighlight,
                false
            );
        });

        this.$refs.dropArea.addEventListener('drop', this.handleDrop, false);

        this.uploadProgress = [];
    },
};
</script>
